import { useState, type FormEvent } from "react";
import { Icon } from "../../icons/Icon";
import { Brasao } from "../../components/Layout";
import { api } from "../../lib/api";

/**
 * Entrada do painel.
 *
 * Login por um POST comum (JSON no corpo), que cria a sessão do Spring
 * Security no servidor; as requisições seguintes seguem pelo cookie. A
 * mensagem de erro é sempre a mesma para usuário inexistente e senha errada,
 * para não confirmar quais e-mails existem.
 */
export function Login({ aoEntrar }: { aoEntrar: () => void }) {
  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [erro, setErro] = useState<string | null>(null);
  const [entrando, setEntrando] = useState(false);

  async function enviar(ev: FormEvent) {
    ev.preventDefault();
    setEntrando(true);
    setErro(null);
    try {
      await api.post("/api/admin/login", { email, senha });
      aoEntrar();
    } catch {
      setErro("E-mail ou senha incorretos.");
      setSenha("");
    } finally {
      setEntrando(false);
    }
  }

  return (
    <main style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      <div className="login-faixa">
        <div className="container" style={{ display: "flex", alignItems: "center", gap: "var(--space-4)" }}>
          <Brasao tamanho={44} className="login-brasao" />
          <strong style={{ color: "var(--color-text-inverse)", fontSize: "var(--text-lg)" }}>
            Painel da Comissão
          </strong>
        </div>
      </div>

      <div style={{ flex: 1, display: "grid", placeItems: "center", padding: "var(--gutter)" }}>
        <div style={{ width: "min(26rem, 100%)" }} className="pilha pilha-6">
          <form onSubmit={enviar} className="cartao pilha" noValidate>
            <h1 className="h3">Entrar</h1>

            {erro && (
              <div className="aviso aviso-erro" role="alert">
                <Icon nome="alerta" tamanho={18} />
                <div>{erro}</div>
              </div>
            )}

            <div className="campo">
              <label className="campo-rotulo" htmlFor="email">E-mail institucional</label>
              <input id="email" type="email" className="entrada" value={email}
                     autoComplete="username" required
                     onChange={(e) => setEmail(e.target.value)} />
            </div>

            <div className="campo">
              <label className="campo-rotulo" htmlFor="senha">Senha</label>
              <input id="senha" type="password" className="entrada" value={senha}
                     autoComplete="current-password" required
                     onChange={(e) => setSenha(e.target.value)} />
            </div>

            <button type="submit" className="btn btn-primario btn-largo" disabled={entrando}>
              {entrando ? <span className="carregando" /> : <Icon nome="cadeado" tamanho={18} />}
              {entrando ? "Entrando" : "Entrar"}
            </button>
          </form>

          <p className="texto-sutil">
            Acesso restrito aos membros da Comissão Especial Avaliadora. Todo acesso a dado
            pessoal de candidato é registrado em log de auditoria.
          </p>
        </div>
      </div>
    </main>
  );
}
